// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","435":"ba9f299b","455":"a9ba13ed","457":"850f3002","484":"14cb0921","851":"3f0086ba","977":"240addac"}[chunkId] + ".chunk.js";
};